import { render, staticRenderFns } from "./StudipDialog.vue?vue&type=template&id=12c08a11&"
import script from "./StudipDialog.vue?vue&type=script&lang=js&"
export * from "./StudipDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports